/* * 收入排行榜 */
<template>
  <div class="rankView">
    <div class="header" :style="{backgroundImage:`url(${images.rank_bg})`}">收入排行榜</div>
    <div class="rankContainer">
      <div class="tabs">
        <span
          :class="`tab ${types === 'week' ? 'select' : ''}`"
          @click="rankTabClickEvent('week')"
          >周榜</span
        >
        <span
          :class="`tab ${types === 'month' ? 'select' : ''}`"
          @click="rankTabClickEvent('month')"
          >月榜</span
        >
        <span
          :class="`tab ${types === 'total' ? 'select' : ''}`"
          @click="rankTabClickEvent('total')"
          >总榜</span
        >
      </div>
      <div class="items">
        <div class="item" v-for="(item, index) in data" :key="index">
          <img v-if="index === 0" class="icon" :src="images.gold" />
          <img v-else-if="index === 1" class="icon" :src="images.silver" />
          <img v-else-if="index === 2" class="icon" :src="images.bronze" />
          <span v-else class="number">{{ index + 1 }}</span>
          <span :class="`name ${index <= 2?'select':''}`" @click="jumpToCompany(item)">{{item.company && item.company.name}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  IMG_MEDAL_GOLD,
  IMG_MEDAL_SILVER,
  IMG_MEDAL_BRONZE,
  IMG_RANK_BG
} from '../assets';

import { types as CompanyTypes } from "../store/modules/company";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "CompanyRank",
  data() {
    return {
      images:{
        gold: IMG_MEDAL_GOLD,
        silver: IMG_MEDAL_SILVER,
        bronze: IMG_MEDAL_BRONZE,
        rank_bg: IMG_RANK_BG
      },  
      types: "week",
    };
  },
  computed: {
    ...mapState({
      data: state => state.company.rank_data
    })
  },
  methods: {
    ...mapActions({
      fetchData: CompanyTypes.FETCH_RANK_LIST
    }),

    // 排行榜，周榜、月榜、总榜点击事件
    rankTabClickEvent(type){
      this.types = type;
      this.fetchData({"tag":this.types});
    },
    //跳到个人主页
    jumpToCompany(item){
      let company_id = item.company.pk;
      this.$router.push(`/company/${company_id}`);
    }
  },
  created() {},
  destroyed() {},
  mounted() {
    this.fetchData(this.types);
  }
};
</script>

<style lang="less" scoped>
.rankView {
  background-color: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 10px;
  .header {
    height: 50px;
    background-color: #ff7b00;
    font-size: 15px;
    color: #ffffff;
    text-align: center;
    line-height: 50px;
    background-repeat: no-repeat;
    background-size: 100%;
    font-weight: bold;
  }
  .rankContainer {
    .tabs {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      padding-top: 10px;
      .tab {
        color: #666666;
        font-size: 15px;
        margin-left: 15px;
        margin-right: 15px;
        padding-bottom: 3px;
        cursor: pointer;
        &.select {
          color: #6b45e1;
          border-bottom: solid 1.5px #6b45e1;
        }
      }
    }
    .items {
      margin-bottom: 20px;
      margin-top: 10px;
      .item {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 40px;
        font-size: 14px;
        padding: 0 20px;
        .icon {
          width: 20px;
          margin-right: 10px;
        }
        .name {
          height: 40px;
          overflow: hidden;
          line-height: 40px;
          flex: 1;
          cursor: pointer;
          text-align: right;
          &:hover{
            color: #eb7350;
          }
          &.select{
            color: #eb7350;
          }
        }
        .segment{
          color: #666666;
          font-size: 11px;
          margin-left: 20px;
        }
        .number {
          color: #5158ff;
          font-weight: bold;
          width: 20px;
          text-align: center;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>
